<div *ngIf="question?.modularQuestions" class="table">
    <div class="replay" 
        *ngFor="let rowIndex of [].constructor(rows$());let i=index;">
        <div class="header">
            <p translate [translateParams]="{ index : i+1}">
                questionBoard.edit.reply
            </p>
            <img
            [ngClass]="{'pointer':isUser$()}"
            *ngIf="question?.toNum!=undefined && rows$()>1" src="/assets/images/question-menu/delete.svg" (click)="isUser$()?delete(i+1):null">
        </div>
        <div class="contain">
            <div class="answer" *ngFor="let mq of question?.modularQuestions">
                <que-question-group-item-dispaly [questionId]="question?.id" [required]="question?.requierd" [modularQuestion]="mq"
                    [modularOrder]="i+1" [isPreview]="isPreview"></que-question-group-item-dispaly>
            </div>
        </div> 
    </div>
</div>
<div  [ngClass]="{'pointer':isUser$()}" *ngIf="question?.toNum" class="addAnswer" (click)="isUser$()?addModularAnswer():null">
    <img src="/assets/images/options/add-question.svg">
    <p *ngIf="question?.text else placeholderText">{{question?.text}}</p>
</div>

<ng-template #placeholderText>
    <p translate>questionBoard.edit.group.placeholder-display</p>
</ng-template>